(async () => {
	const debugMode = 1,
		testId = "GLX-035",
		logInfo = testId + " -->",
		variation = 1;

	try {
		// Avoid code to run multiple times
		if (!document.documentElement.classList.contains(`${testId}_var_${variation}`)) {
			document.documentElement.classList.add(`${testId}_var_${variation}`);
			document.documentElement.classList.add(`${testId}_var`);

			// Tampermonkey has a specific window scope. This will make sure you access the correct website's "window" object.
			let _window = window;
			if (typeof unsafeWindow !== "undefined") _window = unsafeWindow;

			_window._conv_q = _window._conv_q || [];

			// Wait for the main content wrapper
			const waitForElement = (selector) => {
				try {
					return new Promise((resolve) => {
						try {
							if (document.querySelector(selector)) {
								resolve(document.querySelector(selector));
								return;
							}

							const observer = new MutationObserver(() => {
								try {
									if (document.querySelector(selector)) {
										observer.disconnect();
										resolve(document.querySelector(selector));
									}
								} catch (err) {
									if (debugMode) console.error(logInfo, err.message);
								}
							});

							observer.observe(document.documentElement, {
								childList: true,
								subtree: true
							});
						} catch (err) {
							if (debugMode) console.error(logInfo, err.message);
						}
					});
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			// Wait for an element(s) to be fully loaded in the DOM
			const sentConvertEvent = (number, label = "") => {
				try {
					_conv_q.push(["triggerConversion", number]);

					if (debugMode) console.log(logInfo, "Convert event sent:", number, label);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			const sendGAEvent = (category) => {
				try {
					let _category = `hd_${category.toLowerCase().trim().replace(/ /gi, "_")}`;

					_window.dataLayer = _window.dataLayer || [];
					_window.dataLayer.push({
						event: _category
					});

					if (debugMode) console.log(logInfo, "Sent GA event:", _category);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			waitForElement("header-sidebar .header-sidebar__main-panel .header-sidebar__footer").then((headerSidebarFooter) => {
				try {
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			});
		}
	} catch (err) {
		if (debugMode) console.error(logInfo, err.message);
	}
})();